<!-- 固定在左下角的小助手按鈕 -->
<button
  class="ai-customer-service-btn"
  (click)="openModal()"
  [title]="'ai_customer_service.button_title' | translate"
  [attr.aria-label]="'ai_customer_service.button_label' | translate">
  <i class="fas fa-robot"></i>
</button>

<!-- Modal 彈出視窗 -->
<div
  class="modal-overlay"
  [class.fullscreen-overlay]="isFullscreen"
  *ngIf="isModalOpen"
  (click)="onModalBackdropClick($event)">

  <div class="modal-container" [class.fullscreen]="isFullscreen">
    <!-- Modal 標題列 -->
    <div class="modal-header">
      <h3>{{ 'ai_customer_service.title' | translate }}</h3>
      <div class="header-buttons">
        <!-- 文字大小調整按鈕 -->
        <button
          class="font-size-button decrease-font"
          (click)="adjustFontSize('decrease')"
          [disabled]="currentFontSize <= minFontSize"
          [attr.aria-label]="'ai_customer_service.decrease_font_label' | translate"
          title="縮小文字">
          <i class="fas fa-minus"></i>
        </button>
        <button
          class="font-size-button reset-font"
          (click)="adjustFontSize('reset')"
          [attr.aria-label]="'ai_customer_service.reset_font_label' | translate"
          title="預設文字大小">
          <i class="fas fa-font"></i>
        </button>
        <button
          class="font-size-button increase-font"
          (click)="adjustFontSize('increase')"
          [disabled]="currentFontSize >= maxFontSize"
          [attr.aria-label]="'ai_customer_service.increase_font_label' | translate"
          title="放大文字">
          <i class="fas fa-plus"></i>
        </button>

        <!-- 分隔線 -->
        <div class="button-separator"></div>

        <button
          class="fullscreen-button"
          (click)="toggleFullscreen()"
          [attr.aria-label]="(isFullscreen ? 'ai_customer_service.exit_fullscreen_label' : 'ai_customer_service.fullscreen_label') | translate">
          <i class="fas" [class.fa-expand]="!isFullscreen" [class.fa-compress]="isFullscreen"></i>
        </button>
        <button
          class="close-button"
          (click)="closeModal()"
          [attr.aria-label]="'ai_customer_service.close_label' | translate">
          <i class="fas fa-times"></i>
        </button>
      </div>
    </div>

    <!-- 對話區域 -->
    <div class="modal-body">
      <div class="chat-container">
        <div class="chat-messages">
          <div
            *ngFor="let message of chatMessages"
            [class]="'message ' + message.role">

            <div class="message-bubble">
              <div class="message-content">
                <app-markdown-viewer
                  *ngIf="message.role === 'assistant'"
                  [markdownContent]="message.content">
                </app-markdown-viewer>
                <span *ngIf="message.role === 'user'">{{ message.content }}</span>
              </div>
            </div>
          </div>

          <!-- 載入中指示器 -->
          <div *ngIf="isSendingMessage" class="message assistant">
            <div class="message-bubble">
              <div class="typing-indicator">
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 輸入區域 -->
    <div class="modal-footer">
      <div class="input-container">
        <textarea
          #messageTextarea
          [(ngModel)]="userMessage"
          (keydown)="onEnterKey($event)"
          (input)="autoResize($event)"
          [placeholder]="'ai_customer_service.input_placeholder' | translate"
          class="message-input"
          rows="2"
          [disabled]="isSendingMessage">
        </textarea>
        <button
          (click)="sendMessage()"
          class="send-button"
          [disabled]="!userMessage.trim() || isSendingMessage"
          [attr.aria-label]="'ai_customer_service.send_label' | translate">
          <i class="fas fa-paper-plane"></i>
        </button>
      </div>
    </div>
  </div>
</div>
